import { render, staticRenderFns } from "./GroupCreation.html?vue&type=template&id=0cf48d49&scoped=true&external"
import script from "./GroupCreation.vue?vue&type=script&lang=js"
export * from "./GroupCreation.vue?vue&type=script&lang=js"
import style0 from "./GroupCreation.scss?vue&type=style&index=0&id=0cf48d49&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf48d49",
  null
  
)

export default component.exports